import { Countries } from '../../i18n';

function getTVAIntraComFromCompanyNumber(companyNumber: number | string, countryCode: string): string {
    if (typeof companyNumber === 'number') {
        companyNumber = companyNumber.toString();
    }

    // Unable to process non string values
    if (typeof companyNumber !== 'string') {
        return '';
    }

    if (isTVAIntraComSupportedForCountry(countryCode) === false) {
        return '';
    }

    let tva = companyNumber.toString();

    const toString = companyNumber.toString();
    let withoutSpaces = toString.replace(/\s/g, ''); // Replace spaces and non breaking spaces

    if (countryCode === Countries.France) {
        const subStringed = withoutSpaces.substring(0, 9);
        const a = parseInt(subStringed, 10) % 97;
        const b = 3 * a;
        const c = 12 + b;
        const keyTVA = c % 97;
        tva = `${countryCode + keyTVA.toString() + subStringed}`;
    } else if (countryCode === Countries.Belgium) {
        withoutSpaces = withoutSpaces.replace(/\./g, ''); // from: BE0769.853.564 to BE0769853564

        if (withoutSpaces.substring(0, 2) === Countries.Belgium) {
            // example: BE0769853564
            withoutSpaces = withoutSpaces.substring(2); // remove: BE
        }

        const subStringed = withoutSpaces.substring(0, 10);
        tva = `${countryCode + subStringed}`;
    } else if (countryCode === Countries.Italy) {
        tva = `${countryCode}${withoutSpaces}`; // IT01530620994
    } else if (countryCode === Countries.Switzerland) {
        withoutSpaces = withoutSpaces.replace(/\./g, ''); // from: CHE-101.646.961 to CHE-101646961
        withoutSpaces = withoutSpaces.replace('CHE-', ''); // from: CHE-101.646.961 to 101646961
        withoutSpaces = withoutSpaces.replace('CHE', ''); // from: CHE 101.646.961 to 101646961
        const subStringed = withoutSpaces.substring(0, 9);
        // See: https://www.estv.admin.ch/estv/fr/accueil/taxe-sur-la-valeur-ajoutee/ide/numero-identification-entreprises-ide.html
        tva = `CHE${subStringed}TVA`; // Needs to match VatNumberUtilStatic::generateFromCompanyNumber
    }

    return tva;
}

/**
 * Returns a boolean if the country is known, null if not
 * Sync with onestaff-api/app/Util/VatNumberUtilStatic.php
 */
function isTVAIntraComSupportedForCountry(countryCode: string): boolean | null {
    if (countryCode === Countries.France) {
        return true;
    } else if (countryCode === Countries.Belgium) {
        return true;
    } else if (countryCode === Countries.Switzerland) {
        return true;
    } else if (countryCode === Countries.UnitedKingdom) {
        return false;
    } else if (countryCode === Countries.Netherlands) {
        return false;
    } else if (countryCode === Countries.Ireland) {
        return false;
    } else if (countryCode === Countries.Luxembourg) {
        return false;
    } else if (countryCode === Countries.UnitedStates) {
        return false;
    } else if (countryCode === Countries.Cyprus) {
        return false;
    } else if (countryCode === Countries.Italy) {
        return true;
    } else if (countryCode === Countries.Romania) {
        return false;
    } else if (countryCode === Countries.Germany) {
        return false;
    }

    return null;
}

export type TvaReturn = {
    isTVAIntraComSupportedForCountry: Function;
    getTVAIntraComFromCompanyNumber: Function;
};

export const tva = (): TvaReturn => {
    return {
        isTVAIntraComSupportedForCountry,
        getTVAIntraComFromCompanyNumber,
    };
};
